import React, { useEffect, useState, useRef } from "react";
import classes from "./Purchaseinvoice.module.css";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../Assets/searchicon.png";
import filter from "../../Assets/filter.png";
import Footer from "../../Components/Footer/Footer";
import { Pen, Trash2, Printer, HandCoins } from "lucide-react";
import axios from "axios";
import api, { BASE_URL, getAuthHeaders } from "../../Components/API/Api";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Swal from 'sweetalert2';
import LoanAppModal from "./LoanAppModal";
import LoanAppModalExcel from "./LoanAppModalExcel";
import LoanUpload from "./LoanUpload";
import LoanUpload1 from "./LoanUpload1";


const LoanApplication = () => {
  const location = useLocation();
  const navigate = useNavigate();
   const [openLoanAppModal, setOpenLoanAppModal] = useState(false);
   const [openLoanAppModalExcel, setOpenLoanAppModalExcel] = useState(false);
   const [openLoanAppModalExcel1, setOpenLoanAppModalExcel1] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectMetrics, setSelectedMetrics] = useState(null);
  const printRef = useRef();
  const [loanMode, setLoanMode] = useState("new");
const [requestLoanData, setRequestLoanData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  
  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };





  // useEffect(() => {
  //   const fetchInvoices = async () => {
  //     try {
  //       const res = await axios.get(`${BASE_URL}/v1/fetch-purchases-invoice`, {
  //         headers: getAuthHeaders(),
  //       });
  //       if (res.data && res.data.status && Array.isArray(res.data.data)) {
  //         setInvoices(res.data.data);
  //       }
  //     } catch (err) {
  //       setInvoices([]);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchInvoices();
  // }, []);



const [page, setPage] = useState(1);

const [pagination, setPagination] = useState({
  current_page: 1,
  last_page: '',
  total: '',
  per_page: '',
});


  const fetchInvoices = async () => {
    setLoading(true);

    try {
      const res = await api.get(
        `/v1/fetch_loan_applications?page=${page}`
      );

      const paginatedData = res.data?.data;

      setInvoices(paginatedData?.data || []);

      setPagination({
        current_page: paginatedData?.current_page || 1,
        last_page: paginatedData?.last_page || 1,
        total: paginatedData?.total || 0,
        per_page: paginatedData?.per_page || 15,
      });
    } catch (error) {
      console.error(error);
      setInvoices([]);
    } finally {
      setLoading(false);
    }
  };

useEffect(() => {
  fetchInvoices();
}, []);

  const statusClass = (approved) => {
  if (Number(approved) === 1) return classes.greenStatus; // Approved
  if (Number(approved) === 0) return classes.yellowStatus; // Pending
  if (Number(approved) === 2) return classes.redStatus; // Disapproved

  return classes.yellowStatus;
};


  const getDeliveryStatus = (item) => {
    const rawValue = item?.is_supplied ?? item?.delivery_status ?? item?.status;

    if (rawValue == 1 || rawValue === "1") {
      return { text: "delivered", class: classes.greenStatus };
    }
    if (rawValue == 0 || rawValue === "0") {
      return { text: "not delivered", class: classes.yellowStatus };
    }

    return { text: String(rawValue || "not delivered"), class: classes.yellowStatus };
  };
  useEffect(() => {


    const fetchMetrics = async () => {
      try {
        const res = await api.get("/v1/metrics/purchase-invoice-matrix");
        if (res.data && res.data.status && res.data.data) {
          setSelectedMetrics(res.data.data);
        }
      } catch (err) {
        setSelectedMetrics(null);
      }
    };
    fetchMetrics();
  }, []);

  const handlePrint = (rowData) => {
    navigate("/invoice-previeww", {
      state: { invoice: rowData, pageTitle: "Purchase Invoice" },
    });
  };

  const handleReversePurchaseInvoice = async (item) => {
    // Confirm deletion
    const result = await Swal.fire({
      title: 'Reverse Purchase Invoice',
      text: 'Are you sure you want to reverse this purchase invoice? This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, reverse it!'
    });

    if (!result.isConfirmed) {
      return;
    }

    try {
      const response = await api.post(`/v1/reverse-purchase-invoice`, {
        invoice_id: item.id,
        invoice_number: item.invoice_number || item.document_number
      });

      if (response.status === 200 || response.status === 201) {
        // Remove the item from the table
        setInvoices(invoices.filter(invoice => invoice.id !== item.id));
        Swal.fire({
          title: 'Success!',
          text: 'Purchase invoice reversed successfully.',
          icon: 'success',
          confirmButtonColor: '#3085d6'
        });
      }
    } catch (error) {
      console.error("Failed to reverse invoice:", error);
      Swal.fire({
        title: 'Error!',
        text: error.response?.data?.message?.invoice_number?.[0] || 'Error reversing purchase invoice. Please try again.',
        icon: 'error',
        confirmButtonColor: '#3085d6'
      });
    }
  };

const handlePaymentSuccess = () => {
  setPage(1);
};

const handleFirstPage = () => {
  setPage(1);
};

const handlePreviousPage = () => {
  if (pagination.current_page > 1) {
    setPage((prev) => prev - 1);
  }
};

const handleNextPage = () => {
  if (pagination.current_page < pagination.last_page) {
    setPage((prev) => prev + 1);
  }
};

const handleLastPage = () => {
  setPage(pagination.last_page);
};



  return (
    <div>
      <HeaderNav activePage={pageMap[location.pathname]} />

      <div className={classes.Container}>
        {/* <div className={classes.actionsbtn}>
          <button className={classes.btns}>New Sales Invoice</button>
          <button className={classes.btns}>New Purchase Invoice</button>
          <button className={classes.btns}>All Invoices</button>
          <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
        </div> */}

        <header className={classes.Header}>
          <h2 className={classes.Title}>Loan Applications</h2>
          <h1 className={classes.Titles}>
            Process new loan applications, review member loan balances, and manage repayment details.
          </h1>
        </header>

        <div className={classes.entrjj}>
          <div className={classes.allkads}>
            <div className={classes.thrdkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Total Loan Applications</p>
                <p className={classes.kdptg1}>0.00</p>
                {/* <p className={classes.kdptg1}>{selectMetrics?.total_purchase?.toLocaleString() ?? '0'}</p> */}
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>This month</p>
                </div>
              </div>
            </div>
            <div className={classes.frtkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Total Disbursement</p>
                <p className={classes.kdptg2}>0.00</p>
                {/* <p className={classes.kdptg2}>{selectMetrics?.outstanding?.toLocaleString() ?? '0'}</p> */}
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>Pending payments</p>
                </div>
              </div>
            </div>
            <div className={classes.frstkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Entries</p>
                {/* <p className={classes.kdptg4}>{selectMetrics?.total_invoices?.toLocaleString() ?? '0'}</p> */}
                <p className={classes.kdptg4}>0.00</p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>Total invoices</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={classes.headerActions}>
          <div className={classes.actionsRight}>
            <div className={classes.inputWrapper}>
              <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
              <input type="text" className={classes.searchBar} placeholder="Search loan applications" />
            </div>
            {/* <div className={classes.selectWrapper}>
              <select className={classes.dropdown}>
                <option value="">All Status</option>
                <option value="Paid">Paid</option>
                <option value="Pending">Pending</option>
                <option value="Overdue">Overdue</option>
                <option value="Draft">Draft</option>
              </select>
              <span className={classes.dropdownArrow}>▼</span>
            </div> */}

            {/* <div className={classes.inputWrapper}>
              <input type="text" className={classes.searchBars} placeholder="Filter..." />
              <img src={filter} alt="Filter" className={classes.inputIcon} />
            </div> */}
          </div>
          <div style={{
            display: 'flex',
            gap: 10,
          }}>

          <button className={classes.btnss1} onClick={() => setOpenLoanAppModalExcel1(true)}> + Upload Excel</button>
          <button className={classes.btnss} onClick={() => {
    setLoanMode("new");
    setRequestLoanData(null);
    setOpenLoanAppModal(true);
}}> + New Loan Application</button>
          </div>
        </div>

        <div className={classes.invoicecont}>
          <table className={classes.invoiceTable}>
            <table className={classes.invoiceTable}>
              <thead style={{ whiteSpace: "nowrap" }}>
                <tr>
                  <th>S/N</th>
                  <th>Member Name</th>
                  <th>Loan Product</th>
                  <th>Transaction Date</th>
                  <th>Principal Amount</th>
                  <th>Interest Amount</th>
                  {/* <th>Monthly Deduction</th> */}
                  <th>Total Amount</th>
                  {/* <th>Balance</th> */}
                  {/* <th>Duration (months)</th> */}
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>

                {loading
                  ? Array(5)
                    .fill()
                    .map((_, idx) => (
                      <tr key={idx}>
                        {Array(9)
                          .fill()
                          .map((_, i) => (
                            <td key={i}>
                              <Skeleton height={20} style={{ marginBottom: 10 }} />
                            </td>
                          ))}
                      </tr>
                    ))
                  : invoices.length === 0 ? (
                    <tr>
                      <td colSpan={10} style={{ textAlign: "center" }}>
                        No loan application found.
                      </td>
                    </tr>
                  ) : (
                    invoices.map((item, index) => (
                      <tr key={item.id}>
                        <td>{(pagination.current_page - 1) *
    pagination.per_page +
    index +
    1}</td>
                        <td>{item.member?.name}</td>
                        <td>{item.loan?.loan_name}</td>
                         <td>{item.transaction_date}</td>
                        <td style={{ textAlign: 'right' }}>{Number(item.principal_amount).toLocaleString('en-NG', { minimumFractionDigits: 2 })}</td>
                        <td style={{ textAlign: 'right' }}>{Number(item.interest_amount).toLocaleString('en-NG', { minimumFractionDigits: 2 })}</td>
                        {/* <td style={{ textAlign: 'right' }}>{Number(item.monthly_deduction).toLocaleString('en-NG', { minimumFractionDigits: 2 })}</td> */}
                        
                        <td style={{ textAlign: 'right' }}>{Number(item.total_repayment).toLocaleString('en-NG', { minimumFractionDigits: 2 })}</td>
                        {/* <td style={{ textAlign: 'right' }}>{Number(item.balance).toLocaleString('en-NG', { minimumFractionDigits: 2 })}</td> */}
                       
                        {/* <td>{item.duration}</td> */}
                      <td className={statusClass(item.approved)}>
  {Number(item.approved) === 1
    ? "Approved"
    : Number(item.approved) === 2
    ? "Disapproved"
    : "Pending"}
</td>
                        <td className={classes.actions}>
                         {Number(item.is_request) === 0 && (
    <HandCoins
        className={classes.editIcon}
        color="#3B82F6"
        onClick={() => {
            setLoanMode("additional");
            setRequestLoanData(item);
            setOpenLoanAppModal(true);
        }}
        style={{ cursor: "pointer" }}
    />
)}
                          <Pen size={16} className={classes.editIcon} />
                          <Trash2 
                            size={16} 
                            className={classes.deleteIcon}
                            // onClick={() => handleReversePurchaseInvoice(item)}
                            style={{ cursor: "pointer" }}
                          />
                          {/* <Printer size={16} className={classes.printIcon} onClick={() => handlePrint(item)}
                            style={{ cursor: "pointer" }} /> */}
                        </td>
                      </tr>
                    ))
                  )}
              </tbody>
            </table>


          </table>

         <div className={classes.paginationContainer}>
  <div className={classes.paginationControls}>
    <button
      onClick={handleFirstPage}
      disabled={pagination.current_page === 1}
    >
      First
    </button>

    <button
      onClick={handlePreviousPage}
      disabled={pagination.current_page === 1}
    >
      Previous
    </button>

    {Array.from(
      { length: pagination.last_page },
      (_, i) => i + 1
    )
      .slice(
        Math.max(0, pagination.current_page - 3),
        Math.max(5, pagination.current_page + 2)
      )
      .map((pageNumber) => (
        <button
          key={pageNumber}
          onClick={() => setPage(pageNumber)}
          className={
            pagination.current_page === pageNumber
              ? classes.active
              : ""
          }
        >
          {pageNumber}
        </button>
      ))}

    <button
      onClick={handleNextPage}
      disabled={
        pagination.current_page === pagination.last_page
      }
    >
      Next
    </button>

    <button
      onClick={handleLastPage}
      disabled={
        pagination.current_page === pagination.last_page
      }
    >
      Last
    </button>

    <span className={classes.pageText}>
      Displaying{" "}
      {pagination.total === 0
        ? 0
        : (pagination.current_page - 1) *
            pagination.per_page +
          1}
      {" - "}
      {Math.min(
        pagination.current_page *
          pagination.per_page,
        pagination.total
      )}
      {" of "}
      {pagination.total}
    </span>
  </div>
</div>


        </div>
      </div>
       <LoanAppModal
    isOpen={openLoanAppModal}
    onClose={() => setOpenLoanAppModal(false)}
    onSuccess={fetchInvoices}
    mode={loanMode}
    requestData={requestLoanData}
/>
      <LoanUpload1
  isOpen={openLoanAppModalExcel1}
  onClose={() => setOpenLoanAppModalExcel1(false)}
  onUploadDocument={() => {
    setOpenLoanAppModalExcel1(false); // Close LoanUpload1
    setOpenLoanAppModalExcel(true);   // Open LoanUpload
  }}
/>
       <LoanUpload isOpen={openLoanAppModalExcel} onClose={() => setOpenLoanAppModalExcel(false)}
        onSuccess={fetchInvoices}
        />
      <Footer />
    </div>
  );
};

export default LoanApplication;
